import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { UpdateWorksheetEntryFields } from '../types/worksheet-entry';
import queryClient from '../query-client';

export type UpdateWorksheetEntriesRequest = (UpdateWorksheetEntryFields & { source?: null })[];

async function updateWorksheetEntries(workpaperId: string, worksheetId: string, request: UpdateWorksheetEntriesRequest): Promise<void> {
    await api.patch(`/workpapers/${workpaperId}/worksheets/${worksheetId}/entries`, request);
}

export function useUpdateWorksheetEntries(
    worksheetId: string
): UseMutationResult<void, AxiosError, UpdateWorksheetEntriesRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => updateWorksheetEntries(workpaperId, worksheetId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['entries', worksheetId]);
            queryClient.invalidateQueries(['worksheets', worksheetId]);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
            queryClient.invalidateQueries(['history']);
        },
    });
}
